import { CheckCircle2, AlertTriangle, XCircle, CircleDashed } from "lucide-react";

const STYLES = {
  green: { bg: "var(--rag-green-bg)", text: "var(--rag-green-text)", Icon: CheckCircle2, label: "Green" },
  amber: { bg: "var(--rag-amber-bg)", text: "var(--rag-amber-text)", Icon: AlertTriangle, label: "Amber" },
  red:   { bg: "var(--rag-red-bg)",   text: "var(--rag-red-text)",   Icon: XCircle,       label: "Red" },
  neutral: { bg: "#EFEEE8", text: "#4B4F4C", Icon: CircleDashed, label: "—" },
};

export function StatusBadge({ status = "neutral", label, size = "sm", testId }) {
  const s = STYLES[status] || STYLES.neutral;
  const padding = size === "lg" ? "px-3 py-1.5 text-sm" : "px-2.5 py-1 text-xs";
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 rounded-full ${padding} font-medium font-mono-ui`}
      style={{ backgroundColor: s.bg, color: s.text }}
    >
      <s.Icon className="h-3.5 w-3.5" strokeWidth={2.25} />
      {label || s.label}
    </span>
  );
}

export const ragLabelMap = {
  green: "Green",
  amber: "Amber",
  red: "Red",
};
